import { KolumnaSpisuFiltrowanie } from '../spis/kolumnaSpisuFiltrowanie';

export class UruchomFiltrPorownywaniaDanychModel {
  kolumnyFiltrowania: Array<KolumnaSpisuFiltrowanie> = new Array();
  idLokalizacji: string;
  idProjektu: string;
  idFiltra: string;
}
